module.exports = __webpack_public_path__ + "static/media/FitnessGirlSignup2.7b8c2938.png";